import React, {useState} from 'react'
import {Container} from 'react-bootstrap'
import './style.css'
import {Link} from 'react-router-dom'

export default function Alamat() {

    const [click, setClick] = useState(false)

    const toggleHandler = i => {
        if(click === i) {
           return setClick(null)
        }
        setClick(i)

    }

    return (
        <>
            {
               DataPembeli.map((item, i) => {
                   return (
                        <Container key={i} className={click === i ? "comp-alamat comp-alamat-active" : "comp-alamat"}>
                            <div className="input" onClick={() => toggleHandler(i)}>
                                <div className={click === i ? "tombol tombol-active" : "tombol"}></div>
                            </div>
                            <div className="comp-title">
                                <h3>{item.title}</h3>
                                <p className="name">{item.name}</p>
                                <p className="phone">{item.phone}</p>
                                <p className="alamat">{item.alamat}</p>
                                <Link to="#">{item.edit}</Link>
                            </div>
                        </Container>
                   )
               })
            }
        </>
    )
}

const DataPembeli = [
    {title:"Rumah Pak Rifqi", name:"Rifki", phone:"0853 4186 4089", alamat:"Pondok Informatika Abdesir, Jln. Bontobila I, Batua, Makassar, Sulawesi Selatan", edit:"Ubah Alamat"},
    {title:"Rumah Pak Umar", name:"Umar", phone:"0853 4186 4089", alamat:"Pondok Informatika Abdesir, Jln. Bontobila I, Batua, Makassar, Sulawesi Selatan", edit:"Ubah Alamat"}
]
